export default function CarouselItem({ imgUrl, imgTitle }) {
  return (
    <div className="carousel-item w-full h-[400px] rounded overflow-hidden bg-gray-100">
      <img
        src={imgUrl}
        alt=""
        className="lg:w-full lg:h-full sm:w-auto sm:h-auto object-cover"
      />
    </div>
  );
}
